var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ds-control mobile dsf_teas_student_report" },
    [
      _c("div", { staticClass: "report-content" }, [
        _c("div", { staticClass: "stu-infor" }, [
          _c("div", { staticClass: "title" }, [_vm._v("学员信息")]),
          _c("div", { staticClass: "stu-items" }, [
            _c("div", { staticClass: "stu-item topLine" }, [
              _c("div", { staticClass: "stu-item-left" }, [_vm._v("学员姓名")]),
              _c("div", { staticClass: "stu-item-right" }, [
                _vm._v(_vm._s(_vm.attendInfor.xm)),
              ]),
            ]),
            _c("div", { staticClass: "stu-item" }, [
              _c("div", { staticClass: "stu-item-left" }, [_vm._v("手机号码")]),
              _c("div", { staticClass: "stu-item-right" }, [
                _vm._v(_vm._s(_vm.attendInfor.sjhm)),
              ]),
            ]),
            _c("div", { staticClass: "stu-item" }, [
              _c("div", { staticClass: "stu-item-left" }, [_vm._v("身份证号")]),
              _c("div", { staticClass: "stu-item-right" }, [
                _vm._v(_vm._s(_vm.attendInfor.sfzh)),
              ]),
            ]),
            _c("div", { staticClass: "stu-item noBtmPadding" }, [
              _c("div", { staticClass: "stu-item-left" }, [_vm._v("组别")]),
              _c("div", { staticClass: "stu-item-right" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.attendInfor.group_name
                        ? _vm.attendInfor.group_name
                        : "暂无分组"
                    ) +
                    " "
                ),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "class-infor" }, [
          _c("div", { staticClass: "title" }, [_vm._v("班级信息")]),
          _c("div", { staticClass: "class-items" }, [
            _c("div", { staticClass: "class-item topLine" }, [
              _c("div", { staticClass: "class-item-left" }, [
                _vm._v("班级名称"),
              ]),
              _c("div", { staticClass: "class-item-right" }, [
                _vm._v(" " + _vm._s(_vm.attendInfor.class_name) + " "),
              ]),
            ]),
            _c("div", { staticClass: "class-item" }, [
              _c("div", { staticClass: "class-item-left" }, [
                _vm._v("培训时间"),
              ]),
              _c("div", { staticClass: "class-item-right" }, [
                _vm._v(" " + _vm._s(_vm.attendInfor.pxsj) + " "),
              ]),
            ]),
            _c("div", { staticClass: "class-item" }, [
              _c("div", { staticClass: "class-item-left" }, [_vm._v("班主任")]),
              _c("div", { staticClass: "class-item-right" }, [
                _vm._v(_vm._s(_vm.attendInfor.bzr_text)),
              ]),
            ]),
            _c("div", { staticClass: "class-item noBtmPadding" }, [
              _c("div", { staticClass: "class-item-left" }, [
                _vm._v("上课地点"),
              ]),
              _c("div", { staticClass: "class-item-right" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.attendInfor.skdd_text
                        ? _vm.attendInfor.skdd_text
                        : "暂无"
                    ) +
                    " "
                ),
              ]),
            ]),
          ]),
        ]),
        _vm.type == 2
          ? _c("div", { staticClass: "scan-infor" }, [
              _vm.attendInfor.status_value == "1"
                ? _c("div", { staticClass: "reportSucess" }, [
                    _c("img", {
                      staticClass: "img",
                      attrs: {
                        src: require("_teas/assets/themes/img/reportResouse/bdcg.png"),
                        alt: "",
                        srcset: "",
                      },
                    }),
                    _c("div", { staticClass: "success" }, [
                      _c("div", { staticClass: "title" }, [
                        _vm._v("报到成功，欢迎您来参加培训！"),
                      ]),
                      _c("div", { staticClass: "time" }, [
                        _vm._v(_vm._s(_vm.attendInfor.register_date)),
                      ]),
                    ]),
                  ])
                : _c("div", { staticClass: "noReport" }, [
                    _c("img", {
                      staticClass: "img",
                      attrs: {
                        src: require("_teas/assets/themes/img/reportResouse/wbd2.png"),
                        alt: "",
                        srcset: "",
                      },
                    }),
                    _c("div", { staticClass: "title" }, [_vm._v("未报到")]),
                  ]),
            ])
          : _c("div", { staticClass: "location-infor" }, [
              _vm.attendInfor.status_value == "1"
                ? _c("div", { staticClass: "reportSucess" }, [
                    _c("img", {
                      staticClass: "img",
                      attrs: {
                        src: require("_teas/assets/themes/img/reportResouse/dwcg.png"),
                        alt: "",
                        srcset: "",
                      },
                    }),
                    _c("div", { staticClass: "success" }, [
                      _c("div", { staticClass: "tip" }, [
                        _vm._v("定位报到成功"),
                      ]),
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.attendInfor.registerLocation)),
                      ]),
                      _c("div", { staticClass: "time" }, [
                        _vm._v(_vm._s(_vm.attendInfor.register_date)),
                      ]),
                    ]),
                  ])
                : _c("div", { staticClass: "noReport" }, [
                    _c("img", {
                      staticClass: "img",
                      attrs: {
                        src: require("_teas/assets/themes/img/reportResouse/wbd.png"),
                        alt: "",
                        srcset: "",
                      },
                    }),
                    _c("div", { staticClass: "title" }, [
                      _c("div", [_vm._v("未报到")]),
                      _c("div", { staticClass: "address" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.locationInfor.address
                                ? _vm.locationInfor.address
                                : ""
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "locationbtn",
                        on: { click: _vm.locationAddr },
                      },
                      [_vm._v("一键导航")]
                    ),
                  ]),
            ]),
      ]),
      _vm.attendInfor.status_value == "0"
        ? _c(
            "van-button",
            {
              staticClass: "btn-scan",
              class: _vm.attendInfor.status_value == 1 ? "hasReportBtn" : "",
              attrs: { type: "primary", block: "" },
              on: { click: _vm.clickReport },
            },
            [_vm._v(" 报到 ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }